var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSolrplexIconMobile = function SvgSolrplexIconMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "solrplex-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55494",
    transform: "translate(5774.082 13203)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4323",
    cx: 8,
    cy: 8,
    transform: "translate(-5774.082 -13203)",
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108504",
    d: "M-5768.368-13187.332a7.994 7.994 0 0 1-3.313-1.954h3.313Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108505",
    d: "M-5768.368-13189.289h4.568a1.143 1.143 0 0 0 0-2.286h-3.425a1.142 1.142 0 0 0-1.143 1.143Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108506",
    d: "M-5773.312-13191.571a7.945 7.945 0 0 1-.689-2.286h5.633v1.143a1.143 1.143 0 0 1-1.143 1.143Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108507",
    d: "M-5767.225-13196.143h5.714a1.143 1.143 0 0 1 0 2.286h-6.857v-1.143a1.143 1.143 0 0 1 1.143-1.143Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108508",
    d: "M-5774.001-13196.143a7.944 7.944 0 0 1 .689-2.286h4.944v1.143a1.143 1.143 0 0 1-1.143 1.143Z",
    "data-fill": "a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108509",
    d: "M-5768.368-13198.429h4.568a1.143 1.143 0 0 0 0-2.286h-3.425a1.143 1.143 0 0 0-1.143 1.143Z",
    "data-fill": "a"
  }))));
};
export default SvgSolrplexIconMobile;